import { FC } from 'react';
import { IReinjuryRiskMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import styles from '../AthleteInjuryCharts.module.scss';

interface Props {
  data: IReinjuryRiskMetric | null;
  period?: string;
}

const LEVEL_COLOR: Record<string, string> = {
  low: 'var(--ri-good)',
  moderate: 'var(--ri-normal)',
  high: 'var(--ri-warning)',
  'very-high': 'var(--ri-critical)',
};

const LEVEL_LABEL: Record<string, string> = {
  low: 'Basso',
  moderate: 'Moderato',
  high: 'Alto',
  'very-high': 'Molto alto',
};

export const ReinjuryRiskCard: FC<Props> = ({ data }) => {
  if (!data) {
    return <ChartEmptyState />;
  }

  const color = LEVEL_COLOR[data.level] ?? 'var(--c-text-3)';
  const label = LEVEL_LABEL[data.level] ?? data.level;
  const maxContribution = Math.max(...(data.factors?.map((f) => f.contribution) ?? [1]));

  return (
    <div className={styles.riskCard}>
      <div className={styles.riskScoreWrap}>
        {/* Colore calcolato a runtime dal livello di rischio: eccezione ammessa allo stile inline. */}
        <div className={styles.riskScoreValue} style={{ color }}>
          {data.score}
        </div>
        <div className={styles.riskScoreLabel} style={{ color }}>
          {label}
        </div>
      </div>
      {data.factors && data.factors.length > 0 && (
        <div>
          <div className={styles.riskFactorsLabel}>Fattori contributivi</div>
          {data.factors.map((factor, i) => (
            <div key={i} className={styles.riskFactorRow}>
              <div className={styles.riskFactorHeader}>
                <span>{factor.label}</span>
                <span className={styles.riskFactorValue}>{factor.contribution}</span>
              </div>
              <div className={styles.riskFactorTrack}>
                {/* Larghezza proporzionale al contributo: valore runtime, non tokenizzabile. */}
                <div
                  className={styles.riskFactorFill}
                  style={{ width: `${(factor.contribution / maxContribution) * 100}%`, background: color }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
